import * as React from "react";

import {
  ReactCheckout2022Route,
  useReactCheckout2022Router,
} from "../providers";

import { PortalToPaymentPageBelowSection } from "../portals";

export const Footer: React.FunctionComponent = () => {
  const currentYear = new Date().getFullYear();

  return (
    <FooterPortal>
      <footer className="bbnt-uses-page-width-max--from-the-inside">
        <p>{`© ${currentYear} Bed Bath N’ Table. All Rights Reserved`}</p>
      </footer>
    </FooterPortal>
  );
};

const FooterPortal: React.FunctionComponent = (props) => {
  const { currentRoute } = useReactCheckout2022Router();
  if (currentRoute === ReactCheckout2022Route.payment) {
    return (
      <PortalToPaymentPageBelowSection>
        {props.children || []}
      </PortalToPaymentPageBelowSection>
    );
  }
  return <React.Fragment>{props.children || []}</React.Fragment>;
};
